import React from 'react';

function Mobile() {
  return <div>Attendence</div>;
}

export default Mobile;
